// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SecurityPipelineNavIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={8.75} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={12} cy={12} r={3.75} stroke="currentColor" strokeWidth={1.5} />
    <circle cx={12} cy={18.25} r={0.75} fill="currentColor" />
    <circle
      cx={7.58}
      cy={16.42}
      r={0.75}
      fill="currentColor"
      transform="rotate(45 7.58 16.42)"
    />
    <circle
      cx={5.75}
      cy={12}
      r={0.75}
      fill="currentColor"
      transform="rotate(90 5.75 12)"
    />
    <circle
      cx={7.58}
      cy={7.58}
      r={0.75}
      fill="currentColor"
      transform="rotate(135 7.58 7.58)"
    />
    <circle cx={12} cy={5.75} r={0.75} fill="currentColor" />
    <circle
      cx={16.42}
      cy={7.58}
      r={0.75}
      fill="currentColor"
      transform="rotate(45 16.42 7.58)"
    />
    <circle
      cx={18.25}
      cy={12}
      r={0.75}
      fill="currentColor"
      transform="rotate(90 18.25 12)"
    />
    <circle
      cx={16.42}
      cy={16.42}
      r={0.75}
      fill="currentColor"
      transform="rotate(135 16.42 16.42)"
    />
  </svg>,
  "SecurityPipelineNav",
);
export default SecurityPipelineNavIcon;
